export default __webpack_public_path__ + "static/media/blog-39-1.425ca9af.png";